import { render, staticRenderFns } from "./ObtainedSpecialityMultiplePickerInput_v2.vue?vue&type=template&id=1432a034&scoped=true&"
import script from "./ObtainedSpecialityMultiplePickerInput_v2.vue?vue&type=script&lang=js&"
export * from "./ObtainedSpecialityMultiplePickerInput_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1432a034",
  null
  
)

export default component.exports